// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC7SuqULmP880_1QFFP9JU6C84ZWF3_-rE",
  authDomain: "school-website-8100a.firebaseapp.com",
  projectId: "school-website-8100a",
  storageBucket: "school-website-8100a.firebasestorage.app",
  messagingSenderId: "552841425804",
  appId: "1:552841425804:web:a99ddbbd8ff95a4a549ca9",
  measurementId: "G-2GE588SN3N",
};

const app = initializeApp(firebaseConfig);

// ✅ Only run analytics in the browser
if (typeof window !== "undefined") {
  getAnalytics(app);
}

const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
